import {
    FETCH_CUSTOM_MESSAGE_SUCCESS,
    FETCH_CUSTOM_MESSAGE_ERROR,
    FETCH_CUSTOM_MESSAGE_LOADING
} from "./index" 

import {apiCall} from "../../functions/utils"

export const fetchCustomMessageSuccess = (data) => {
    return {
        type : FETCH_CUSTOM_MESSAGE_SUCCESS,
        payload: data
    }
}

export const fetchCustomMessageError = (error) => {
    return {
        type : FETCH_CUSTOM_MESSAGE_ERROR,
        error
    }
}

export const fetchCustomMessageLoading = () => {
    return {
        type : FETCH_CUSTOM_MESSAGE_LOADING
    }
}

export const fetchCustomMessages = (query = "", page = 1) => {
    return async (dispatch) => {
        dispatch(fetchCustomMessageLoading())
        try{
            const res = await apiCall(true, "GET", `/api/custom-messages`)
            dispatch(fetchCustomMessageSuccess(res.data))
        }catch(e){
            dispatch(fetchCustomMessageError(e))
        } 
    }
}

export const updatecustomMessage = (formData, recordId = false ) => {

    return async (dispatch, getState) => {
        dispatch(fetchCustomMessageLoading())
        try{
            if( recordId ){
                await apiCall(true, "POST", `/api/custom-messages/update/${recordId}`, formData, false, true, true)

            }else{
                await apiCall(true, "POST", `/api/custom-messages/store`, formData, false, true, true)
            }
            dispatch(fetchCustomMessages())
        }catch(e){
            dispatch(fetchCustomMessageError(e))
        } 

    }
    
  }

  export const deleteCustomMessage = ( recordId ) => {

    return async (dispatch, getState) => {
        dispatch(fetchCustomMessageLoading())
        try{
            await apiCall(true, "DELETE", `/api/custom-messages/${recordId}` )
            dispatch(fetchCustomMessages())

        }catch(e){
            dispatch(fetchCustomMessageError(e))
        } 

    }
   
  }